








import { Component, Vue } from 'vue-property-decorator';
import { IForgotPassword } from '@/interfaces';
import { showAxiosErrorMessage } from '@/utils';
import { AjaxHelper } from '@/AjaxHelper';

import ForgotPasswordForm from '@/components/forms/ForgotPasswordForm.vue';

@Component({
  name: 'forgot-password-page',
  components: { ForgotPasswordForm }
})
export default class ForgotPasswordComponent extends Vue {
  /**
   * Loading data into the system
   */
  public loading = false;

  /**
   * Helper method for when the form is submitted
   * 
   * @param model The forgot password process
   */
  public async submit(model: IForgotPassword) {
    try {
      this.loading = true;

      await AjaxHelper.post('/resetpassword', model)
      this.$alert.success('Password Reset Email Sent', 'Please check your email to find the reset link');
      this.$router.push('/user/login');
    } catch(ex) {
      showAxiosErrorMessage(ex);
    } finally {
      this.loading = false;
    }
  }
}
